<template>
  <li
    class="cordel-simple-list-item"
    tabindex="0"
  >
    <span
      :is="item.href ? 'router-link' : 'span'"
      :to="item.href"
      class="cordel-simple-list-link"
    >
      <typography-title
        class="cordel-simple-list-item-title"
        hierarchy="h3"
      >
        {{ item.title }}

        <slot />
      </typography-title>

      <font-awesome-icon
        class="cordel-simple-list-item-chevron"
        icon="fa-solid fa-chevron-right"
      />
    </span>
  </li>
</template>

<script>
  import TypographyTitle from '@cordel/components/Typography/Title.vue';

  export default {
    name: 'CordelSimpleListItem',
    components: {
      TypographyTitle,
    },
    props: {
      item: {
        type: Object,
        default() {
          return {};
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .cordel-simple-list-item {
    border-color: var(--cordel-color-neutral-light);
    border-style: solid;
    border-width: 0 0 var(--cordel-border-width-soft);

    &:last-child {
      border-width: 0;
    }
  }

  .cordel-simple-list-link {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: var(--cordel-spacing-s);
    justify-content: center;
    padding: var(--cordel-spacing-xl) var(--product--pwa--horizontal);

    @media all and (max-width: 768px) {
      padding: var(--cordel-spacing-xl) var(--product--pwa--horizontal);
    }

    &:hover {
      background: var(--cordel-color-neutral-lighter);
    }

    &:focus {
      box-shadow: inset 0 0 0 var(--cordel-border-width-thin) var(--cordel-color-highlight-primary);
      outline: none;
    }
  }

  .cordel-simple-list-item-title {
    flex: 1;
  }

  .cordel-simple-list-item-chevron {
    font-size: var(--cordel-font-size-xl);

    @media all and (max-width: 768px) {
      font-size: var(--cordel-font-size-l);
    }
  }
</style>
